/**
 * Bridges Monster Cart (third-party cart drawer app) with the theme.
 *
 * Monster handles add-to-cart and line item changes itself and only emits its own
 * `cart:updated` event, so the header cart bubble would otherwise go stale.
 *
 * The bubble is updated directly instead of dispatching the theme's `cart:update`
 * event: that event is shared with `CartAddEvent` and would auto-open the native
 * cart drawer.
 */
document.addEventListener('cart:updated', (event) => {
  if (!(event instanceof CustomEvent)) return;

  /** @type {{ quantity: number }[] | undefined} */
  const items = event.detail?.items;
  if (!Array.isArray(items)) return;

  const itemCount = items.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

  for (const cartIcon of document.querySelectorAll('cart-icon')) {
    if ('renderCartBubble' in cartIcon && typeof cartIcon.renderCartBubble === 'function') {
      cartIcon.renderCartBubble(itemCount, false);
    }
  }
});
